import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
// import "./quillStyles.css"; // Import custom styles

const Attributes = ({ attributeDetails, handleAttributeDetailsChange, setSourceTypeOther, setCountryOther, sourceTypeOther, countryOther }) => {
  const [sourceData, setSourceData] = useState([]);
  const [sourceTypeData, setSourceTypeData] = useState([]);
  const [countryOriginData, setCountryOriginData] = useState([]);
  const [toggleEditor, setToggleEditor] = useState(false);
  const [sourceTypeSelectedValue, setSourceTypeSelectedValue] = useState("");
  const [countrySelectedValue, setCountrySelectedValue] = useState("");
  const [sourceTypeCustomInput, setSourceTypeCustomInput] = useState("")
  const [countryCustomInput, setCountryCustomInput] = useState("")


  const fetchDetails = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URI}/elixir/all-info`
      );

      if (res.status !== 200) {
        throw new Error("Error Fetching Data");
      }


      setSourceData(res.data.source);
      setSourceTypeData(res.data.source_type);
      setCountryOriginData(res.data.country_origin);
    } catch (error) {
      let errorMessage = "Something went wrong. Please try again.";

    if (error.response) {
      // API returned an error response (e.g., 400, 401, 403, 404, 500)
      errorMessage = `Error ${error.response.status}: ${error.response.data?.detail || "Request failed"}`;
    } else if (error.request) {
      // No response received (Network issue)
      errorMessage = "Network error. Please check your internet connection.";
    } else {
      // Other unknown errors
      errorMessage = "Unexpected error occurred.";
    }

    toast.error(errorMessage);
    console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const handleToggle = (value) => {
    setToggleEditor(!value);
  };

  const handleSourceTypeChange = (e) => {
    const { value } = e.target;

    if (value === "Others (Please Specify)") {
      setSourceTypeOther(true);
      setSourceTypeSelectedValue(""); // Reset selected value until user enters custom input
    } else {
      setSourceTypeOther(false);
      setSourceTypeCustomInput(""); // Reset custom input field
      setSourceTypeSelectedValue(value);
      handleAttributeDetailsChange({ target: { name: "Source Type", value } });
    }
  };

  const handleSourceTypeEnterPress = (e) => {
  
    if (e.key === "Enter" && sourceTypeCustomInput.trim()) {
      const customValue = sourceTypeCustomInput.trim();
      setSourceTypeSelectedValue(customValue); // Set entered value as selected option

    
      handleAttributeDetailsChange({
        target: { name: "Source Type", value: customValue },
      });

      setSourceTypeCustomInput("");
      setSourceTypeOther(false); // Hide input field after selection
    }
  };

  const handleCountryEnterPress = (e) => {
 

    if (e.key === "Enter" && countryCustomInput.trim()) {
      const customValue = countryCustomInput.trim();
      setCountrySelectedValue(customValue); // Set entered value as selected option

     
      handleAttributeDetailsChange({
        target: { name: "country", value: customValue },
      });

      setCountryCustomInput("")
      setCountryOther(false); // Hide input field after selection
    }
  };

  const handleCountryChange = (e) => {
    const { value } = e.target;

    if (value === "Others (Please Specify)") {
      setCountryOther(true);
      setCountrySelectedValue(""); // Reset selected value until user enters custom input
    } else {
      setCountryOther(false);
      setCountryCustomInput(""); // Reset custom input field
      setCountrySelectedValue(value);
      handleAttributeDetailsChange({ target: { name: "country", value } });
    }
  };

  const renderComponent = (name, value, onChange) => {
    if (name === "source") {
      return (
        <div className="flex justify-center self-center items-center w-full sm:w-full">
          {/* <input type="text" /> */}
          <ReactQuill
            name={name}
            value={value}
            onChange={(val) =>
              onChange({
                target: { name, value: val.trim() },
              })
            }
            theme="snow"
            className="bg-gray-700 text-white  w-full "
            required
          />

        </div>
      );

      
    }

    if (name === "Source Type") {
      return (
        <>
          <div className="flex flex-col justify-center w-full">
            <select
              name={name}
              value={value || ""}
              onChange={handleSourceTypeChange}
              className="border rounded px-4 py-2 bg-gray-700 text-gray-200 w-full "
            >
              <option value="">Select Source Type</option>
              {sourceTypeData.map((currElem, index) => (
                <option key={index} value={currElem}>
                  {currElem}
                </option>
              ))}
              <option value="Others (Please Specify)">Others (Please Specify)</option>
            </select>

            {
              sourceTypeOther && (
                <input
                  type="text"
                  value={sourceTypeCustomInput}
                  onChange={(e) => setSourceTypeCustomInput(e.target.value)}
                  onKeyDown={handleSourceTypeEnterPress}
                  placeholder="Enter custom classification and press Enter"
                  className="border border-gray-600 rounded px-4 py-2 bg-gray-700 text-gray-200 mt-2"
                  autoFocus
                />
              )
            }

            {sourceTypeSelectedValue &&
              !sourceTypeData.includes(sourceTypeSelectedValue) &&
              !sourceTypeOther && (
                <span className="mt-2 text-gray-300 ">
                  Selected :{" "}
                  <span className="text-md font-semibold">{sourceTypeSelectedValue}</span>{" "}
                </span>
              )}
          </div>
        </>
      );
    }

    if (name === "country") {
      return (

        <div className="flex flex-col w-full">
          <select
            name={name}
            value={value || ""}
            onChange={handleCountryChange}
            className="border  rounded px-4 py-2 bg-gray-700 text-gray-200 w-full sm:w-full"
          >
            <option value="">Select Country</option>
            {countryOriginData.map((currElem, index) => (
              <option key={index} value={currElem}>
                {currElem}
              </option>
            ))}
            <option value="Others (Please Specify)">Others (Please Specify)</option>
          </select>

          {
            countryOther && (
              <input
                type="text"
                value={countryCustomInput}
                onChange={(e) => setCountryCustomInput(e.target.value)}
                onKeyDown={handleCountryEnterPress}
                placeholder="Enter custom country and press Enter"
                className="border border-gray-600 rounded px-4 py-2 bg-gray-700 text-gray-200 mt-2"
                autoFocus
              />
            )
          }

          {countrySelectedValue &&
            !countryOriginData.includes(countrySelectedValue) &&
            !countryOther && (
              <span className="mt-2 text-gray-300 ">
                Selected :{" "}
                <span className="text-xl font-bold">{countrySelectedValue}</span>{" "}
              </span>
            )}

        </div>

      );
    }

    return (
      <textarea
        name={[name]}
        type="text"
        value={value || ""}
        onChange={onChange}
        className="border p-2 rounded bg-gray-600 text-white overflow-auto w-full h-12"
      />
    );
  };

  return (
    <div className="flex flex-col items-center w-full">
      <div className="w-full max-w-2xl my-7 space-y-3 overflow-auto">
        <h2 className="text-xl font-semibold text-center text-white">
          Ingredient Details
        </h2>
        <table className="w-full table-auto bg-gray-700 text-gray-200 rounded-lg text-center ">
          <thead>
            <tr>
              <th className="px-4 py-2 text-center">Item Attributes</th>
              <th className="px-4 py-2 text-center">Value</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(attributeDetails).map((attributeName, index) => (
              <tr key={index} className="border-t border-gray-600 text-center">
                <td className="px-4 py-2 capitalize text-center">
                  {attributeName}
                </td>
                <td className="px-4 py-2 text-center ">
                  <div className="flex justify-center">
                    {renderComponent(
                      attributeName,
                      attributeDetails[attributeName],
                      handleAttributeDetailsChange
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Attributes;

//     (attributeName === "source" ? (
//     <div className="w-72 h-64 min-h-[8rem] md:ml-20 bg-white text-black rounded-md overflow-hidden border border-gray-600">
//         <ReactQuill
//             value={value}
//             onChange={(value) =>
//                 onChange({
//                     target: { name: name, value },
//                 })
//             }
//             theme="snow"
//             className="h-32 "
//         />
//     </div>
// ) : (
//     <input
//         type="text"
//         name={attributeName}
//         value={attributeDetails[attributeName]}
//         onChange={handleAttributeDetailsChange}
//         className="border border-gray-600 rounded px-4 py-2 bg-gray-500 text-gray-200 w-72 text-center"
//     />
// ))}
